import { AlphaGBoxOutlineIcon } from './AlphaGBoxOutlineIcon';

/**
 * author: Contributors
 * id D9ED1661-B57E-47E9-B727-F03BC035DE4D
 * name alpha-g-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-g-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetGBoxOutlineIcon = AlphaGBoxOutlineIcon;
export default AlphabetGBoxOutlineIcon